module.exports = __webpack_public_path__ + "img/logintitle.45c41438.jpg";